import { Checkbox } from 'components/Checkbox/Checkbox'
import { colors } from 'settings/colors'
import type { TAvailablePreset } from 'stores/userDetailsStore/helperTypes'
import { DuplicatePresetButton } from '../../DuplicatePresetButton/DuplicatePresetButton'
import { togglePreset } from '../../_utils/togglePreset'

export const ItemRow = ({
  preset,
  duplicatePreset,
}: {
  preset: TAvailablePreset
  duplicatePreset: (preset: TAvailablePreset) => void
}) => {
  const { idHash, ignored, name } = preset

  return (
    <div
      css={{
        width: '100%',
        display: 'flex',
        padding: '12px 4px',
        borderTop: `1px solid ${colors.grey200}`,
        borderBottom: `1px solid ${colors.grey200}`,
        justifyContent: 'space-between',
        flexWrap: 'wrap',
      }}
    >
      <Checkbox
        checked={!ignored}
        label={<span css={{ fontWeight: 500 }}>{name}</span>}
        onChange={() => togglePreset({ idHash, newIgnored: !ignored, presetType: 'semiosDefined' })}
        size="md"
      />
      <DuplicatePresetButton duplicatePreset={duplicatePreset} preset={preset} />
    </div>
  )
}
